import { createStyles, Theme } from '@material-ui/core';

export const styles = ({
  palette: {
    common: { white },
    primary,
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    buttonClose: {
      color: white,
      float: 'right',
    },
    leftIcon: {
      marginRight: unit,
      color: white,
      verticalAlign: 'text-bottom',
    },
    title: {
      color: white,
      display: 'inline-block',
      lineHeight: '48px',
      whiteSpace: 'nowrap',
    },
    wrapper: {
      backgroundColor: primary.main,
      padding: unit * 2,
      paddingLeft: `${unit * 3}px !important`,
    },
  });
